<template>
  <div class="bridge">
    <img :class="['line', { glow }]" :src="bridgeImage" alt="" />
    <img
      v-for="i in 6"
      :class="`dot dot${i}`"
      :key="i"
      :src="bridgeDotImage(i)"
      alt=""
    />
  </div>
</template>

<script>
export default {
  props: {
    bridgePath: {
      type: String,
      required: true,
    },
    clearedBridgePath: {
      type: String,
      required: true,
    },
    clearLevel: {
      type: Number,
      default: 0,
    },
    glow: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    bridgeImageBasepath() {
      return 'normal/bridges';
    },
    bridgeImage() {
      return this.$image(this.clearLevel < 6 ? this.bridgePath : this.clearedBridgePath);
    },
  },
  methods: {
    bridgeDotImage(dotIndex) {
      return this.$image(
        `${this.bridgeImageBasepath}/dot_${(dotIndex <= this.clearLevel) ? 'yellow' : 'blue'}.svg`
      )
    },
  },
};
</script>

<style lang="scss" scoped>
.bridge {
  // TODO: ステージのz-indexをvar(--z-index-xx)で管理
  z-index: 1;

  .line {
    transition: filter 0.3s;
    filter: drop-shadow(0px 0px calc(var(--size-base) * 10) transparent);

    &.glow {
      filter: drop-shadow(0px 0px calc(var(--size-base) * 10) #FFDE21);
    }
  }

  .dot {
    position: absolute;
    width: calc(var(--size-base) * 16.44);
  }
}
</style>